export enum CricketStatId {
  Overs = 201,
  PlayersInPlay = 626,
  CurrentBall = 1213,
  BattingTeam = 1238,
  CurrentAction = 1313,
}
